import Box from '@mui/material/Box';
import Chip, { type ChipProps } from '@mui/material/Chip';
import MuiTab, { type TabProps as MuiTabProps } from '@mui/material/Tab';
import type { ReactNode } from 'react';

export type TabProps = Omit<MuiTabProps, 'label'> & {
  label: ReactNode;
  /**
   * Optional chip rendered next to the label. Useful for status badges
   * (e.g. "Capacity", "Full", count badges) without callers re-implementing
   * the label-with-chip layout each time.
   */
  chip?: ChipProps;
};

export const Tab = ({ label, chip, ...rest }: TabProps) => {
  if (chip == null) {
    return <MuiTab label={label} {...rest} />;
  }
  return (
    <MuiTab
      label={
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
          {label}
          <Chip size="small" {...chip} />
        </Box>
      }
      {...rest}
    />
  );
};
